import { render, staticRenderFns } from "./BizRelation.vue?vue&type=template&id=07d5d274&scoped=true&"
import script from "./BizRelation.vue?vue&type=script&lang=js&"
export * from "./BizRelation.vue?vue&type=script&lang=js&"
import style0 from "./BizRelation.vue?vue&type=style&index=0&id=07d5d274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5d274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\ele-dynamic-form\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d5d274')) {
      api.createRecord('07d5d274', component.options)
    } else {
      api.reload('07d5d274', component.options)
    }
    module.hot.accept("./BizRelation.vue?vue&type=template&id=07d5d274&scoped=true&", function () {
      api.rerender('07d5d274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BizRelation.vue"
export default component.exports